import React, {useState} from 'react'
import {useIsFetching} from '@tanstack/react-query'
import {userSelectors} from '../../store/user/userSelectors'
import {WuFooter} from '@npm-questionpro/wick-ui-lib'
import styles from './BaseFooter.module.scss'
import {BaseModal} from '../BaseModal/BaseModal'
import {
  wickUIIconsVersionText,
  wickUIVersionText,
} from '../../constants/footerConstants'
import pkg from '../../../package.json'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../Translation/English/global'

export const BaseFooter: React.FC = () => {
  const accountDetails = userSelectors.useAccountDetails()
  const user = userSelectors.useCurrentUser()
  const isFetchingCount = useIsFetching()
  const isLoading = isFetchingCount > 0
  const [showModal, setShowModal] = useState<boolean>(false)
  const wt = useWt()

  const wickUiLibVersion = pkg.dependencies[
    '@npm-questionpro/wick-ui-lib'
  ].replace(/^\^/, '')
  const wickUiIconVersion = pkg.dependencies[
    '@npm-questionpro/wick-ui-icon'
  ].replace(/^\^/, '')

  const handleOnClickEmpower = (): void => {
    if (user?.isAdmin) {
      setShowModal(!showModal)
    }
  }

  const getWickUIDetails = (): React.JSX.Element => {
    return (
      <BaseModal
        visible={showModal}
        headerTitle={wt(GLOBAL.infoMessage)}
        onCloseModal={() => setShowModal(false)}
        maxWidth="500px"
      >
        <div className={styles.wuiFooterModal}>
          <div>
            {wickUIVersionText} {wickUiLibVersion}
          </div>
          <div>
            {wickUIIconsVersionText} {wickUiIconVersion}
          </div>
        </div>
      </BaseModal>
    )
  }

  return (
    <>
      {showModal && getWickUIDetails()}
      <WuFooter
        className={styles.wuiFooter}
        isLoading={isLoading}
        loadingText={wt(GLOBAL.loading)}
      >
        <div className={styles.wuiFooterDiv} data-i18n-skip>
          QuestionPro {accountDetails?.license?.subtitle}
          <div
            className={styles.wuiFooterBtn}
            onClick={handleOnClickEmpower}
            data-i18n-skip
          >
            #Empower
          </div>
        </div>
      </WuFooter>
    </>
  )
}
